<template>
  
    <div>
      <pesquisa />
    </div>
</template>
<script>
    import pesquisa from "@/components/arealogada/pesquisa/index.vue";

    export default {
        components: {
            pesquisa
        },
        data() {
            return {

            }
        },
        methods: {},
        mounted() {}
    }
</script>
<style>

</style>
    